export default "/images/vendor/flag-icon-css/flags/1x1/sl.svg?f1772cd4436de4f4535ad8725adbd85d";